import { whatsappNumber } from '@hfs/website/constants/contacts'

// Opens a WhatsApp conversation with the Home for Students number, optionally with a pre-filled text
export const getWhatsAppUrl = (message?: string) =>
  message ? `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}` : `https://wa.me/${whatsappNumber}`
